/* eslint semi:0 */
import m from 'mithril'
import BaseView from './BaseView'
import { t, localizedPath, } from 'providers/i18nProvider/i18nProvider'


const DROPDOWN_ITEM_CLASS = 'dropdown-comp__item'


export default class UserToolbarView extends BaseView {


  view(ctrl){
    return this.getCurrentView(ctrl.vm.store, ctrl.vm)
  }

  getCurrentView(user, vm) {
    const { loggedOutView, loggingInView, loggedInView, } = this
    let currentViewMethod = loggedOutView
    if (user.isAuthenticated) {
      currentViewMethod = loggedInView
    } else if (user.isAuthenticating) {
      currentViewMethod = loggingInView
    }
    return currentViewMethod.apply(this, arguments)
  }

  loggedInView(user, vm) {
    const { userPath, image, fullName, messages, } = user.state
    const children = [
      m(
        'a.user-menu__link',
        { href: localizedPath(userPath), },
        m('img.user-menu__avatar', {
          src: image,
          alt: fullName,
        })
      )
    ]
    if (messages > 0) {
      children.push(m('span.user-menu__notifications', messages))
    }
    return [
      m('.user-menu__avatar-wrap.label', children),
      this.userDropdownView(user, vm),
    ]
  }

  userDropdownView({ state: { userPath, messagesPath, }, isAdmin, isImpersonating, }, vm){
    const dropdownItem = ([attrs, children, ]) => m(`a.${ DROPDOWN_ITEM_CLASS }`, attrs, children)
    const children = [
      [{ href: localizedPath(userPath), }, t('header.profile')],
      [{ href: localizedPath(messagesPath), }, t('private_messages.messages'), ],
      [{ href: localizedPath('/edit_settings'), }, t('header.settings'), ],
      [{ href: '/logout', onclick: vm.logoutClick.bind(vm), }, t('header.signout'), ],
    ].map(dropdownItem)
    if (isAdmin) {
      children.unshift(dropdownItem([{ href: '/admin', }, 'Admin', ]))
    }
    if (isImpersonating) {
      children.unshift(
        dropdownItem([
          {
            href: '/admin/unimpersonate',
            onclick: vm.unimpersonateClick.bind(vm),
          },
          'Un-impersonate',
        ])
      )
    }
    return m('nav.dropdown-comp.dropdown-comp--right', children)
  }

  loggingInView(user, vm){
    return m('span.sign-in-up__logging') // TODO: maybe show a spinner/loader or something
  }

  loggedOutView(user, vm){
    return m(
      'a.sign-in-up__facebook-btn',
      {
        onclick: vm.fbLoginClick.bind(vm),
      },
      t('common.connect')
    )
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/UserToolbarView.js